import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPayee401kRateDetails extends Layout {
    sourceDetail401kRate: DataSource;
    table401kDetails: Table;
}
